const isDebug = process.env.REACT_APP_IS_DEBUG === "1" || false;
const isEnvLocal = process.env.REACT_APP_IS_ENVLOCAL === "1" || false;
const urlApi = process.env.REACT_APP_URLAPI || "http://localhost:8080/api-cliente"


/* *********************************** */


const AppConfig = {
  logLevel: !isDebug ? "DEBUG" : "PROD",
  isDebug,
  isEnvLocal,
  urlApi,
  nombreHeader: "x-resec-cliente-token",
}



export default AppConfig;
